module.exports = __webpack_public_path__ + "img/vivek.a7bd85fd.jpg";